<template>
  <modal
    :title="$t(title)"
    :top="'8vh'"
    :visible.sync="isShowDialog"
    width="60%"
    :appendToBody="true"
  >
    <div class="dialogClass">
      <el-tabs v-model="activeName" type="card">
        <!-- 二代网关才展示 -->
        <template v-if="$attrs.rowData.type === 3">
          <!--二代网关兼容一代参数-->
          <el-tab-pane
            :label="$t('integration.network_parameters_01')"
            name="ConfigNet"
          ></el-tab-pane>
          <el-tab-pane
            :label="$t('integration.network_parameters_02')"
            name="TwoNetParams"
          ></el-tab-pane>
          <el-tab-pane :label="$t('integration.alarm_parameters')" name="AlarmParam">
            <span slot="label">
              {{ $t('integration.alarm_parameters') }}
            </span>
          </el-tab-pane>
        </template>
        <el-tab-pane :label="$t('public.net_param')" name="ConfigNet" v-else>
          <span slot="label">
            <i
              class="el-icon-warning"
              :class="activeName === 'ConfigNet' ? 'active' : ''"
              v-show="
                activeName === 'ConfigNet' && $attrs.rowData.configStatus === 1
              "
            ></i>
            {{ $t('integration.network_parameters') }}
          </span>
        </el-tab-pane>
        <el-tab-pane :label="$t('device.config_log')" name="configLog">
          <span slot="label"
            ><i
              class="el-icon-warning"
              :class="activeName === 'configLog' ? 'active' : ''"
              v-show="
                activeName === 'configLog' && $attrs.rowData.configStatus === 1
              "
            ></i
            >{{ $t('integration.configuration_log') }}</span
          >
        </el-tab-pane>
      </el-tabs>
      <div class="tab-content-scroll">
        <keep-alive>
          <component :is="activeName" v-bind="$attrs" />
        </keep-alive>
      </div>
    </div>
  </modal>
</template>

<script>
import ConfigNet from './GenOne/ConfigNet.vue'
import ConfigLog from './ConfigLog.vue'
import AlarmParam from '@/pages/equipment/gateway/modal/ConfigDialog/GenTwo/AlarmParam.vue'
import TwoNetParams from './GenTwo/TwoNetParams.vue'

export default {
  props: ['title', 'isShowConfig'],
  components: {
    ConfigNet,
    ConfigLog,
    AlarmParam,
    TwoNetParams
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShowConfig
      },
      set: function (val) {
        this.$emit('update:isShowConfig', val) // 可以优化成model  或者minx
      }
    }
  },
  data () {
    return {
      activeName: 'ConfigNet'
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$attrs.rowData.type === 3) {
        this.activeName = 'ConfigNet'
      } else {
        this.activeName = 'ConfigNet'
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.dialogClass {
  max-height: 75vh;
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

.active {
  color: red;
  margin-right: 5px;
}

.tab-content-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: var(--primary-color);
  color: #fff;
}
</style>
